// base
import React from 'react';
import { useHistory } from 'react-router-dom';

// styles
import { StyledNotFoundResult } from './style';

// jsons
import loadingAnimations from './404.json';

// components
import { TextButton } from 'components';

// hooks
import { useUser } from 'hooks';

// routes
import { ROUTE_CHART_DASHBOARD } from 'routes/const';

// libraries
import Lottie from 'react-lottie';

export const NotFoundResult: React.FC = () => {
  const history = useHistory();
  const { isLogin, onLogout } = useUser();

  const onClickGoHome = () => {
    if (isLogin) {
      history.push(ROUTE_CHART_DASHBOARD);
    } else {
      onLogout();
    }
  };

  return (
    <StyledNotFoundResult>
      <Lottie
        isClickToPauseDisabled
        options={{
          loop: true,
          autoplay: true,
          animationData: loadingAnimations,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
      />

      <p>
        Oops! The page you&apos;re looking for doesn&apos;t exist.
        <br />
        {isLogin
          ? 'Please check the URL or go back to the homepage.'
          : 'Please check SignIn or SignUp.'}
      </p>

      <TextButton variant="contained" onClick={onClickGoHome} style={{ width: 200 }}>
        {isLogin ? 'Go to Home' : 'Go to Sign In'}
      </TextButton>
    </StyledNotFoundResult>
  );
};
